
import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
    CHECK_DISCHARGE_ALLOWS_REQUEST,
    CHECK_DISCHARGE_ALLOWS_SUCCESS,
    CHECK_DISCHARGE_ALLOWS_FAILURE,
    CHECK_DISCHARGE_ALLOWS_LOADING,
    CHECK_DISCHARGE_ALLOWS_RESET,
} = documentationActions;

function* isDischargeDocumentAllow(action: any): SagaReturnType<any> {
  try {
    yield put({ type: CHECK_DISCHARGE_ALLOWS_LOADING });
    const response = yield call(templateService.checkDischargeDocumentAllow, action.payload);
    if (response?.status === 200) {
      yield put({ type: CHECK_DISCHARGE_ALLOWS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CHECK_DISCHARGE_ALLOWS_FAILURE, payload: error });
  }
}

function* isDischargeDocumentAllowSaga() {
  yield takeEvery(CHECK_DISCHARGE_ALLOWS_REQUEST, isDischargeDocumentAllow);
}

export default isDischargeDocumentAllowSaga;
